<template>
    <div class="step_content">
        <div class="operation_wrapper">
            <span class="step_icon border_leftT"></span>
            <span class="step_icon border_rightT"></span>
            <span class="step_icon border_leftB"></span>
            <span class="step_icon border_rightB"></span>
            <h3 class="task-name-info">任务名称：<span>{{taskName}}</span></h3>
            <el-form ref="form"
                     :model="form"
                     :rules='rules'
                     label-width="250px"
                     class="form">
                <el-row>

                        <el-col :span="24">
                            <el-form-item label="选择本次执法人员：" prop='extractPondPersonList' style="width:100%;margin-bottom:0">
                                <el-button icon="el-icon-plus"  type="primary" plain @click="showPersonDia()" :disabled="disabledFlag">选择</el-button>
                                <div class="selectPersonWrapper" v-if="extractPondPersonList.length > 0">
                                    <p style="margin:10px 0 0">共计 <span>{{extractPondPersonList.length}}</span>名</p>
                                    <!-- 'height':cardMinHeight, -->
                                    <el-scrollbar :style="{'min-height':'30px','max-height':'440px'}">
                                        <p style="margin: 0" v-for="(item,index) in extractPondPersonList" :key="index">{{item.name + (item.deptName?("（" + item.deptName +  "）"):"")}}</p>
                                    </el-scrollbar>
                                </div>
                            </el-form-item>
                        </el-col>

                    <el-col :span="24" style="margin-top:16px;">
                        <el-form-item label="执法人员分组(共分为)：" prop='groupNum' style="width:100%;">
                            <div class="input-slot-box">
                                <el-input-number style="width: 100px;margin-right:30px"  :disabled="disabledFlag" v-model="form.groupNum" controls-position="right" :min="1" :max="10"></el-input-number>
                                <span class="el-input-icon el-input-slot" :class="{'el-input-icon-ie':isIEBrowser()}">组</span>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

        </div>
        <div class="btn_wraper">
            <p class="supervisionNameInfo">监督检查单位：{{supervisionIdsName}}</p>
            <el-tooltip class="item" popper-class="bigScreenPopper" :visible-arrow="false" effect="light" placement="top-start">
                <div slot="content">
                    {{supervisionIdsName}}
                </div>
                <el-button type="text" style="float:right"> 更多> </el-button>
            </el-tooltip>
            <el-button @click="prevStep()" plain>上一步</el-button>
            <el-button type="primary" @click="nextStep()" plain>保存并进入下一步</el-button>
        </div>
        <personSelectDia
                ref="personSelectDiaRef"
                :dialogVisible.sync="extractPersonPondListDialog"
                :taskId.sync="this.form.taskId"
                @setSelectList="setSelectList">
        </personSelectDia>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import personSelectDia from './personSelectDia';
    export default {
        name: "step_four",
        components: {
            personSelectDia
        },
        props:{
            activeStep: {type: Number, default: 4},
            curStep: {type: Number, default: 4},
            extractNum: {type: Number, default: 0},
            historyid: {type: Number, default: -1},
            taskName: {type: String, default: ''},
            supervisionIdsName: {type: String, default: ''},
        },
        data(){

            var checkArrEmpty = (rule, value, cb) => {
                if(this.extractPondPersonList.length == 0){
                    cb(new Error("请选择执法人员"));
                }else{
                    cb();
                }

            };
            return{
                id:"",
                extractPersonPondListDialog:false,
                value: [1],
                extractPondPersonList:[],
                extractPondPersonListString:"",
                formString:"",
                cardMinHeight: document.documentElement.clientHeight - 660  + 'px',
                form:{
                    id:'',
                    taskId:"",
                    extractNum:"",
                    extractorName:"",
                    curStep:"",
                    groupNum:1,
                    groupAvg:0,// 每组人数
                },
                rules: {

                    extractCode:"",
                    extractTime:"",                    extractPondPersonList: [{required: true, validator: checkArrEmpty, trigger: 'change'}],
                    groupNum: [{required: true, message: '请输入分组数', trigger: 'blur'}],
                },
            }
        },
        filters:{

        },
        created(){
            this.form.taskId = this.$route.query.id || '';
            this.getExtractExectorList();

        },
        computed: {
            ...mapState({
                stateData:state=>state.user
            }),
            disabledFlag: function () {
                return this.historyid == 0 || this.curStep > 5;
            }
        },
        methods:{
            getExtractExectorList(){
                // 获取选择执法人员和分组数
                this.$httpReq.get('/projectDoubleExtract/extractexectorfilter/getPersonAndRule?extractTaskId='+this.form.taskId).then(res=>{
                    if(res.data.code == '1' && res.data.data){
                        this.extractPondPersonList = res.data.data.executorList || [];
                        this.extractPondPersonList.forEach((item)=>{
                            item.id = item.personUserId || '';
                            item.name = item.personName || '';
                            item.deptName = item.personDesc || '';
                        })
                        this.form ={...res.data.data.executorFilter};
                        this.formString =  JSON.stringify(this.form);
                        this.extractPondPersonListString = JSON.stringify(this.extractPondPersonList);
                    }else{
                        this.extractPondPersonList = [];
                        this.form.groupNum = 0;
                    }
                })
            },
            prevStep(){
                this.$emit("update:activeStep",this.activeStep - 1)
            },
            nextStep(){

                // this.$emit("update:activeStep",this.activeStep + 1)
                // return 0

                if(this.form.groupNum > this.extractNum){
                    this.$message.error("分组数不能大于抽取项目数，本次任务抽取了" + this.extractNum + "个项目。")
                    return
                }

                let extractPondPersonListLength = this.extractPondPersonList.length;
                let groupNum = this.form.groupNum;
                if(extractPondPersonListLength%groupNum == 0){
                    this.form.groupAvg = parseInt(extractPondPersonListLength/groupNum);
                }else{
                    this.$message.error("本次选择执法人员数未能整除执法人员分组数，请调整。")
                    return
                }
                let formData = JSON.parse(JSON.stringify(this.form))
                if(this.extractPondPersonListString == JSON.stringify(this.extractPondPersonList) && (this.formString==formData) ){
                    this.$emit("update:activeStep",this.activeStep + 1)
                }else {
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            let params = {
                                exectorFilter: formData,
                                extractExectorList: this.extractPondPersonList,
                            }
                            this.$httpReq({
                                url: '/projectDoubleExtract/extractexector/saveList',
                                method: 'post',
                                data: params
                            }).then(({data}) => {
                                if (data && data.code === '1') {
                                    this.$emit("update:activeStep",this.activeStep + 1)
                                    this.$emit("upDateTaskInfo")
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: data.msg
                                    })

                                }
                            })

                        }
                    })
                }

            },

            showPersonDia(){
                this.extractPersonPondListDialog = true;
                this.$refs.personSelectDiaRef.initData(this.extractPondPersonList)
            },
            setSelectList(val){
                this.extractPondPersonList = val;
            },

        },
    }
</script>

<style lang="scss" scoped>

    .step_content{

    }

</style>